import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Options, preventOverflow } from '@popperjs/core';
import { randomId } from 'shared/utils/random-id';

@Component({
    selector: 'app-tooltip',
    templateUrl: './tooltip.component.html',
    styleUrls: ['./tooltip.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class TooltipComponent {
    @Input() public text: string;
    @Input({ required: true }) public accessibleLabel: string;
    @Input() public mobileIconClass = 'icon-regular';
    public rid = randomId();
    public readonly popperOptions = (options: Partial<Options>): Partial<Options> => ({
        ...options,
        modifiers: [
            ...(options.modifiers || []).filter(modifier => modifier.name !== preventOverflow.name),
            {
                ...preventOverflow,
                options: {
                    boundary: 'viewport',
                    padding: 8,
                },
            },
        ],
    });

    onTooltipClick(event: MouseEvent) {
        // Prevent the click event from bubbling up to parent elements
        // This prevents triggering sort actions in table headers
        event.stopPropagation();
    }
}
